/* eslint-disable react/button-has-type */
// routing
import { ApolloClient, ApolloLink, ApolloProvider, from, HttpLink } from '@apollo/client';
// project imports
import { onError } from '@apollo/client/link/error';
import { Alert, Box, Button, Stack } from '@mui/material';
// import { CachePersistor, LocalStorageWrapper } from 'apollo3-cache-persist';
// import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'store';
import { getRoleName } from 'utils/common';
import { cache } from './cache';
import { useEffect, useState } from 'react';
import Routes from 'routes';
import firebase from 'firebase/compat/app';
import useAuth from 'hooks/useAuth';
import NavigationScroll from 'layout/NavigationScroll';
import ThemeCustomization from 'themes';
import Snackbar from 'ui-component/extended/Snackbar';
import Loader from 'ui-component/Loader';
import Locales from 'ui-component/Locales';
import RTLLayout from 'ui-component/RTLLayout';
import { every, includes } from 'lodash';

const App = () => {
    const { defaultRole, user, logout, idToken, handleIdToken, isLoggedIn } = useAuth();
    // const { serviceWorkerUpdated, serviceWorkerRegistration } = useSelector((state) => state.commonWP);
    // const [client, setClient] = useState();
    // const [persistor, setPersistor] = useState();

    const [showUpdateNotification, setShowUpdateNotification] = useState(false);
    const [waitingWorker, setWaitingWorker] = useState(null);

    useEffect(() => {
        const handleServiceWorkerUpdate = (event) => {
            setShowUpdateNotification(true);
            setWaitingWorker(event.detail.waiting);
        };

        navigator.serviceWorker.addEventListener('controllerchange', handleServiceWorkerUpdate);

        // Check if there is a waiting service worker
        if (navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === 'activated') {
            navigator.serviceWorker.getRegistration().then((registration) => {
                if (registration && registration.waiting) {
                    setWaitingWorker(registration.waiting);
                    setShowUpdateNotification(true);
                }
            });
        }

        return () => {
            navigator.serviceWorker.removeEventListener('controllerchange', handleServiceWorkerUpdate);
        };
    }, []);

    const getheader = (headers) => {
        if (!isLoggedIn) {
            return {
                ...headers,
                'content-type': 'application/json',
                [process.env.REACT_APP_R]: 'anonymous'
            };
        }
        return {
            ...headers,
            'content-type': 'application/json',
            [process.env.REACT_APP_R]: every(['Managment', 'Administrator'], (value) => includes(user.userRoles, value))
                ? getRoleName('administrator')
                : getRoleName(defaultRole),
            [process.env.REACT_APP_UI]: user?.idOriginal,
            Authorization: `Bearer ${idToken}`
        };
    };

    const handleUpdateClick = () => {
        // if (waitingWorker) {
        //     waitingWorker.postMessage({ type: 'SKIP_WAITING' });
        //     waitingWorker.addEventListener('statechange', (e) => {
        //         if (e.target.state === 'activated') {
        //             setShowUpdateNotification(false);
        //             window.location.reload();
        //         }
        //     });
        // }

        if (navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === 'activated') {
            navigator.serviceWorker.getRegistration().then((registration) => {
                if (registration && registration.waiting) {
                    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                    registration.waiting.addEventListener('statechange', (e) => {
                        if (e.target.state === 'activated') {
                            window.location.reload();
                        }
                    });
                }
            });
        }
    };

    const httpLink = new HttpLink({ uri: process.env.REACT_APP_URI });

    const handleAuth = new ApolloLink((operation, forward) => {
        operation.setContext(({ headers = {} }) => ({
            // headers: {
            //     ...headers,
            //     'content-type': 'application/json',
            //     [process.env.REACT_APP_R]: every(['Managment', 'Administrator'], (value) => includes(user.userRoles, value))
            //         ? getRoleName('administrator')
            //         : getRoleName(defaultRole),
            //     [process.env.REACT_APP_UI]: user?.idOriginal,
            //     Authorization: `Bearer ${idToken}`
            // }
            headers: getheader(headers)
        }));

        return forward(operation);
    });

    // eslint-disable-next-line consistent-return
    const handleRefreshAndLogout = onError(({ graphQLErrors, networkError }) => {
        if (networkError?.statusCode === 401) {
            logout();
        } else if (graphQLErrors[0]?.extensions.code === 'invalid-jwt') {
            if (defaultRole && idToken && user) {
                return firebase
                    .auth()
                    .currentUser.getIdToken(true)
                    .then(async (token) => {
                        handleIdToken(token);
                        // eslint-disable-next-line no-new
                        await new ApolloLink((operation, forward) => {
                            operation.setContext(({ headers = {} }) => ({
                                headers: {
                                    ...headers,
                                    'content-type': 'application/json',
                                    [process.env.REACT_APP_R]: every(['Managment', 'Administrator'], (value) =>
                                        includes(user.userRoles, value)
                                    )
                                        ? getRoleName('administrator')
                                        : getRoleName(defaultRole),
                                    [process.env.REACT_APP_UI]: user?.idOriginal,
                                    Authorization: `Bearer ${token}`
                                }
                            }));

                            return forward(operation)
                                .then((response) => {
                                    // console.log('Reauthenticattion Success', response);
                                    window.location.reload();
                                })
                                .catch((error) => {
                                    // console.log('Reauthenticattion Error', error);
                                });
                        });
                    });
                // eslint-disable-next-line no-else-return
            } else {
                window.location.reload();
            }
        } else if (graphQLErrors[0]?.extensions.code === 'invalid-headers') {
            window.location.reload();
        } else {
            console.error('GQL Error :', graphQLErrors[0].message);
        }
    });

    // useEffect(() => {
    //     async function init() {
    //         const newPersistor = new CachePersistor({
    //             cache,
    //             storage: new LocalStorageWrapper(window.localStorage),
    //             debug: true,
    //             trigger: 'write'
    //         });
    //         await newPersistor.restore();
    //         setPersistor(newPersistor);
    //         setClient(
    //             new ApolloClient({
    //                 link: from([handleAuth, handleRefreshAndLogout, httpLink]),
    //                 cache
    //             })
    //         );
    //     }

    //     init();
    // }, []);

    // const clearCache = useCallback(() => {
    //     if (!persistor) {
    //         return;
    //     }
    //     persistor.purge();
    // }, [persistor]);

    // const reload = useCallback(() => {
    //     window.location.reload();
    // }, []);

    const createApolloClient = () => {
        const client = new ApolloClient({
            link: from([handleRefreshAndLogout, handleAuth, httpLink]),
            cache
        });
        return client;
    };

    const client = createApolloClient();

    if (!client) {
        return <Loader />;
    }

    return (
        <>
            <ApolloProvider client={client}>
                <ThemeCustomization>
                    {showUpdateNotification && (
                        <Alert
                            action={
                                <Stack direction="row">
                                    <Button
                                        variant="outlined"
                                        sx={{ p: 0.3, mb: '4px', textTransform: 'capitalize' }}
                                        color="inherit"
                                        size="small"
                                        onClick={() => handleUpdateClick()}
                                    >
                                        Update
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        sx={{ p: 0.3, mb: '4px', textTransform: 'capitalize', ml: 2 }}
                                        color="inherit"
                                        size="small"
                                        onClick={() => setShowUpdateNotification(false)}
                                    >
                                        Dismiss
                                    </Button>
                                </Stack>
                            }
                            sx={{
                                ml: isLoggedIn ? { xs: 0, sm: 26 } : 0,
                                mt: isLoggedIn ? { xs: 6.75, sm: 0 } : 0,
                                borderRadius: 0,
                                backgroundColor: '#2e7d32',
                                color: 'white'
                            }}
                            variant="filled"
                        >
                            There is a new version available.
                        </Alert>
                    )}

                    <Box sx={{ mt: showUpdateNotification && isLoggedIn ? { xs: -6.75, sm: 0 } : 0 }}>
                        <RTLLayout>
                            <Locales>
                                <NavigationScroll>
                                    <>
                                        <Routes />
                                        <Snackbar />
                                    </>
                                </NavigationScroll>
                            </Locales>
                        </RTLLayout>
                    </Box>
                </ThemeCustomization>
            </ApolloProvider>
        </>
    );
};

export default App;
